import React, { useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";
import {
  Checkbox,
  Form,
  Input,
  Spin,
} from "antd";
import "../CompanyContactForm.css";
import "./AddressSection.css";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import { toast } from "react-toastify";

import { parseCustomerInfoLocationAddress } from "../../../../helpers";

import { getCustomerInfo } from "../../../../../../actions/onboarding";

export default function AddressSection({
  label, namePath = ["address"], disabled = false, addCompany, companyName,
}) {
  const [loading, setLoading] = useState(false);
  const form = useFormInstance();

  const handleCheckAdd = async (e) => {
    const checked = e.target.checked;

    if (checked) {
      try {
        setLoading(true);
        const CustomerInfo = await getCustomerInfo();

        if (CustomerInfo.message === "Success") {
          form.setFieldValue(["address"], parseCustomerInfoLocationAddress(CustomerInfo));
          form.validateFields([["address"]], { recursive: true, dirty: true });
        } else {
          form.setFieldValue("same_address", false);
          toast.error("Failed to fetch Address!");
        }
        setLoading(false);
      } catch (error) {
        form.setFieldValue("same_address", false);
        toast.error("Failed to fetch Address!");
        setLoading(false);
      }
    } else {
      form.setFieldValue("same_address", false);
    }
  };

  return (
    <Form.Item
      label={label ? <span className="MyForm__SectionLabel">{label}</span> : undefined}
    >

      {addCompany && (
        <>
          {loading ? (
            <div className="BillingAddressSection__Loading">
              <Spin indicator={<LoadingOutlined className="ReportsTable__Checkbox__Spin" spin />} />
              <span className="BillingAddressSection__Address_label">
                Do you want to use the same Company Address as
                {" "}
                {companyName}
                ?
              </span>
            </div>
          )
            : (
              <Form.Item name="same_address" valuePropName="checked">
                <Checkbox className="BillingAddressSection__Checkbox" onChange={handleCheckAdd}>
                  Do you want to use the same Company Address as
                  {" "}
                  {companyName}
                  ?
                </Checkbox>
              </Form.Item>
            )}
        </>
      )}
      <Form.Item
        name={[...namePath, "street"]}
        label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Street address</span>}
        rules={[
          {
            required: !disabled, message: "",
          },
        ]}
        className="AddressSection__FieldRow"
      >
        <Input disabled={disabled} placeholder="Enter Street Address" />
      </Form.Item>
      <Form.Item
        name={[...namePath, "line_2"]}
        label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Street address 2 (optional)</span>}
        className="AddressSection__FieldRow"
      >
        <Input disabled={disabled} placeholder="Building number, apartment number, P.O. box number, etc." />
      </Form.Item>
      <div className="AddressSection__FlexRow">
        <Form.Item
          name={[...namePath, "zipcode"]}
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Zip code</span>}
          rules={[
            {
              required: !disabled, message: "",
            },
          ]}
          className="AddressSection__ShortInput"
        >
          <Input disabled={disabled} placeholder="Enter ZIP Code" />
        </Form.Item>
        <Form.Item
          name={[...namePath, "city"]}
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">City</span>}
          rules={[
            {
              required: !disabled, message: "",
            },
          ]}
          className="AddressSection__ShortInput"
        >
          <Input disabled={disabled} placeholder="Enter City" />
        </Form.Item>
      </div>
      <div className="AddressSection__FlexRow">
        <Form.Item
          name={[...namePath, "country"]}
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">Country</span>}
          rules={[
            {
              required: !disabled, message: "",
            },
          ]}
          className="AddressSection__ShortInput"
        >
          <Input disabled={disabled} placeholder="Enter Country" />
        </Form.Item>
        <Form.Item
          name={[...namePath, "state"]}
          label={<span className="CompanyContactForm__ContactInfoSection_FieldsText">State/Province</span>}
          rules={[
            {
              required: !disabled, message: "",
            },
          ]}
          className="AddressSection__ShortInput"
        >
          <Input disabled={disabled} placeholder="Enter State" />
        </Form.Item>
      </div>

    </Form.Item>
  );
}
